<template>
    <div class="content">
        <div class="category" v-for="category in categories">
            <div class="category-name">{{ category.name }}</div>
            <div class="category-item"
                 v-for="sub in category.subcategory"
                 @click="sub.link ? $router.push(`${sub.link}`) : ''"
            >
                {{ sub.name }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FooterCategories",
       data() {
            return {
                categories: [
                    {
                        name: 'Категории',
                        subcategory: [
                            {
                                name: 'Телефоны',
                                link: ''
                            },
                            {
                                name: 'Наушники',
                                link: ''
                            },
                            {
                                name: 'Гаджеты',
                                link: ''
                            },
                            {
                                name: 'Мужская одежда',
                                link: ''
                            },
                            {
                                name: 'Аксесуары',
                                link: ''
                            }
                        ]
                    },
                    {
                        name: 'Категории 1',
                        subcategory: [
                            {
                                name: 'Телефоны',
                                link: ''
                            },
                            {
                                name: 'Наушники',
                                link: ''
                            },
                            {
                                name: 'Гаджеты',
                                link: ''
                            },
                            {
                                name: 'Мужская одежда',
                                link: ''
                            },
                            {
                                name: 'Аксесуары',
                                link: ''
                            }
                        ]
                    },
                    {
                        name: 'Магазин',
                        subcategory: [
                            {
                                name: 'Лучшие товары',
                                link: 'best-products'
                            },
                            {
                                name: 'О нас',
                                link: 'about-us'
                            },
                            {
                                name: 'Гагантии и возврат',
                                link: 'warranties'
                            },
                            {
                                name: 'Доставка',
                                link: 'shipping'
                            },
                            {
                                name: 'Поддержка',
                                link: 'support'
                            }
                        ]
                    },
                    {
                        name: 'Категории',
                        subcategory: [
                            {
                                name: 'Телефоны',
                                link: ''
                            },
                            {
                                name: 'Наушники',
                                link: ''
                            },
                            {
                                name: 'Гаджеты',
                                link: ''
                            },
                            {
                                name: 'Мужская одежда',
                                link: ''
                            },
                            {
                                name: 'Аксесуары',
                                link: ''
                            }
                        ]
                    }
                ]
            }
       }
    };
</script>

<style scoped lang="scss">
    .content {
        display: flex;
        justify-content: space-evenly;
        .category {
            max-width: 20%;
            &-name {
                color: #FCFCFC;
                font-size: 18px;
                margin-bottom: 15px;
                word-wrap: break-word;
                &:after {
                    background: linear-gradient(39.32deg, #7AC3C1 0%, #3FB0AB 100%);
                    content: '';
                    display: block;
                    height: 2px;
                    width: 40px;
                    margin-top: 6px;
                }
            }
            &-item {
                color: #D8DDE4;
                font-size: 14px;
                margin-bottom: 15px;
                cursor: pointer;
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
</style>
